import { createPortal } from 'react-dom';
import { useDrawer } from '../../contexts/DrawerContext';
import RTIRequestDrawer from '../feature/RTIRequestDrawer';
import SepticTankCleaningDrawer from '../feature/SepticTankCleaningDrawer';
import BulkGarbageCollectionDrawer from '../feature/BulkGarbageCollectionDrawer';
import StreetVendorRegistrationDrawer from '../feature/StreetVendorRegistrationDrawer';
import ComplaintStatusDrawer from '../feature/ComplaintStatusDrawer';
import EFileManagementDrawer from '../feature/EFileManagementDrawer';
import ComplaintCategoryDrawer from '../feature/ComplaintCategoryDrawer';
import ChatDrawer from '../feature/ChatDrawer';
import AIChatDrawer from '../feature/AIChatDrawer';

interface DrawerManagerProps {
  currentLanguage: string;
  onTicketCreated?: () => void;
}

export default function DrawerManager({ currentLanguage, onTicketCreated }: DrawerManagerProps) {
  const { currentDrawer, closeDrawer } = useDrawer();

  // Render drawers using Portal to ensure they appear at root level
  if (typeof window === 'undefined') {
    return null;
  }

  return createPortal(
    <>
      {/* RTI Request Drawer */}
      <RTIRequestDrawer
        isOpen={currentDrawer === 'rti-request'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Septic Tank Cleaning Drawer */}
      <SepticTankCleaningDrawer
        isOpen={currentDrawer === 'septic-tank-cleaning'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Bulk Garbage Collection Drawer */}
      <BulkGarbageCollectionDrawer
        isOpen={currentDrawer === 'bulk-garbage-collection'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Street Vendor Registration Drawer */}
      <StreetVendorRegistrationDrawer
        isOpen={currentDrawer === 'street-vendor-registration'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Complaint Status Drawer */}
      <ComplaintStatusDrawer
        isOpen={currentDrawer === 'complaint-status'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* eFile Management Drawer */}
      <EFileManagementDrawer
        isOpen={currentDrawer === 'e-file-management'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Complaint Category Drawer */}
      <ComplaintCategoryDrawer
        isOpen={currentDrawer === 'complaint-category'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />

      {/* Chat Drawer */}
      <ChatDrawer
        isOpen={currentDrawer === 'chat-drawer'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
        onTicketCreated={onTicketCreated}
      />

      {/* AI Chat Drawer */}
      <AIChatDrawer
        isOpen={currentDrawer === 'ai-chat-drawer'}
        onClose={closeDrawer}
        currentLanguage={currentLanguage}
      />
    </>,
    document.body
  );
}

